var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrSelect',{attrs:{"value":_vm.modelValue,"items":_vm.vastApiFrameworks,"item-text":"title","item-value":"name","label":"Api Frameworks","multiple":"","return-object":"","searchable":"","clearable":true,"loading":_vm.isLoadingVastApiFrameworks},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }